import React, { useState } from 'react'
import { ExperimentOverviewEntry } from '../../Api/experiments'
import { IColumn, Icon } from 'office-ui-fabric-react'
import { TableView } from '../../Components/TableView'
import { ExperimentOverviewEntryDialog } from './ExperimentOverviewEntryDialog'

export function ExperimentOverviewTable({
  experimentOverviewEntries,
}: {
  experimentOverviewEntries: ExperimentOverviewEntry[]
}) {
  const [selectedEntry, setSelectedEntry] =
    useState<ExperimentOverviewEntry | null>(null)
  const columns = useColumns()
  return (
    <>
      <TableView
        cacheKey={''}
        columns={columns}
        rowToCacheKey={() => ''}
        rows={experimentOverviewEntries}
        onRowClick={setSelectedEntry}
      />
      {selectedEntry ? (
        <ExperimentOverviewEntryDialog
          experimentOverviewEntry={selectedEntry}
          onDismiss={() => setSelectedEntry(null)}
        />
      ) : null}
    </>
  )
}

function useColumns(): IColumn[] {
  return [
    {
      key: 'icon',
      name: '',
      fieldName: 'icon',
      minWidth: 20,
      maxWidth: 20,
      isPadded: false,
      isRowHeader: true,
      isIconOnly: true,
      onRender: () => (
        <Icon
          iconName="Website"
          style={{
            fontSize: 14,
            paddingLeft: 5,
            paddingTop: 3,
          }}
        />
      ),
    },
    {
      key: 'domain',
      name: 'Domain',
      fieldName: 'domain',
      minWidth: 150,
      maxWidth: 250,
      isPadded: false,
      isRowHeader: true,
      className: 'none',
      onRender: ({ domain }: ExperimentOverviewEntry) => (
        <span title={domain}>{domain}</span>
      ),
    },
    {
      key: 'experimentTags',
      name: 'Experiment Tags',
      fieldName: 'experimentTags',
      minWidth: 400,
      isPadded: false,
      isRowHeader: true,
      className: 'none',
      onRender: ({ experiments }: ExperimentOverviewEntry) => {
        const tags = experiments.map((experiment) => experiment.tag).join(', ')
        return <span title={tags}>{tags}</span>
      },
    },
  ]
}
